/* Global Header V3: reliable cross-page handoff into Homepage V2 consultation. */
(function () {
  "use strict";

  var HOME = "/";
  var PREVIEW_HOME = "/pages/dr-sknn-home-v2-preview";
  var CONSULTATION_URL = HOME + "?open=consultation";
  var scheduled = false;
  document.documentElement.dataset.drsknnHeaderV3Ready = "true";

  /* A legacy store-level Google Ads listener reads innerText from the exact
     click target. SVG paths do not expose that property, which otherwise logs
     an exception whenever a header icon is clicked. Supply the owning button's
     text during capture so the existing conversion listener remains intact. */
  if (document.documentElement.dataset.drsknnClickTextCompatReady !== "true") {
    document.documentElement.dataset.drsknnClickTextCompatReady = "true";
    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || typeof target.innerText === "string") return;
      var button = target.closest && target.closest("button");
      var fallbackText = button && typeof button.innerText === "string" ? button.innerText : (target.textContent || "");
      try {
        Object.defineProperty(target, "innerText", { configurable: true, value: fallbackText });
      } catch (_) {}
    }, true);
  }

  function closeNavigation() {
    document.querySelectorAll(".dropdown.active").forEach(function (item) {
      item.classList.remove("active");
      var trigger = item.querySelector("button[aria-expanded]");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });
    document.querySelectorAll("[data-drsknn-menu-v2][open]").forEach(function (details) {
      details.removeAttribute("open");
    });
    document.documentElement.classList.remove("drsknn-menu-v2-open");
    document.body.classList.remove("drsknn-menu-v2-open", "overflow-hidden-tablet");
  }

  function openConsultation() {
    closeNavigation();
    if (typeof window.drsknnOpenConsultationChooser === "function") {
      window.drsknnOpenConsultationChooser();
      return;
    }
    var root = document.querySelector("[data-drsknn-v5]");
    var local = root && root.querySelector("[data-v5-open-consultation]");
    if (local) {
      local.click();
      return;
    }
    window.location.assign(CONSULTATION_URL);
  }

  window.openDrSknnConsultation = openConsultation;

  // Book treatment has its own intent. Ordinary pricing links keep their route.
  var TREATMENT_FINDER_URL = "/?open=treatment";
  var treatmentRequest = null;
  var treatmentRequestId = 0;
  var treatmentHandoffScheduled = false;

  function bookingReturnTrigger(trigger) {
    if (!trigger || !trigger.closest) return trigger || null;
    var drawer = trigger.closest("[data-drsknn-menu-v2]");
    if (drawer) return drawer.querySelector("summary") || trigger;
    var dropdown = trigger.closest(".dropdown");
    return dropdown ? dropdown.querySelector("button[aria-expanded]") || trigger : trigger;
  }

  function restoreBookingTrigger(trigger) {
    if (trigger && trigger.isConnected && typeof trigger.focus === "function") trigger.focus({ preventScroll: true });
  }

  function bookingLoadNotice(message, retryHref, trigger) {
    var old = document.querySelector("[data-drsknn-booking-load-status]");
    if (old) old.remove();
    var notice = document.createElement("div");
    notice.setAttribute("data-drsknn-booking-load-status", "");
    notice.style.cssText = "position:fixed;z-index:2147483600;left:50%;bottom:max(18px,env(safe-area-inset-bottom));transform:translateX(-50%);width:min(460px,calc(100vw - 32px));padding:18px;background:#fff;color:#143137;border:1px solid #aaccc6;border-radius:16px;box-shadow:0 12px 44px #062e3433;font:600 15px/1.5 system-ui,sans-serif;display:flex;gap:12px;align-items:center;flex-wrap:wrap";
    var text = document.createElement("span");
    text.setAttribute("role", "status");
    text.setAttribute("aria-live", "polite");
    text.style.cssText = "flex:1 1 200px";
    text.textContent = message;
    notice.appendChild(text);
    if (retryHref) {
      var retry = document.createElement("a");
      retry.href = retryHref;
      retry.textContent = "Reload booking";
      retry.style.cssText = "color:#075b58;text-decoration:underline;font:inherit";
      notice.appendChild(retry);
    }
    var cancel = document.createElement("button");
    cancel.type = "button";
    cancel.textContent = retryHref ? "Dismiss" : "Cancel";
    cancel.style.cssText = "border:1px solid #aaccc6;border-radius:8px;padding:8px 12px;background:#f1f7f5;color:#143137;font:inherit;cursor:pointer";
    cancel.addEventListener("click", function () {
      treatmentRequestId += 1;
      if (treatmentRequest && treatmentRequest.trigger) treatmentRequest.trigger.removeAttribute("aria-busy");
      treatmentRequest = null;
      notice.remove();
      restoreBookingTrigger(trigger);
    });
    notice.appendChild(cancel);
    document.body.appendChild(notice);
    return notice;
  }

  function bookingApiReady() {
    return Boolean(window.DrSknnPricingV3 && typeof window.DrSknnPricingV3.openBookingFinder === "function");
  }

  function loadBookingCatalogue() {
    return new Promise(function (resolve) {
      var settled = false;
      var timeout = window.setTimeout(function () { finish(false); }, 12000);
      function finish(ready) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(Boolean(ready && bookingApiReady()));
      }
      function attempt() {
        if (settled) return;
        if (bookingApiReady()) { finish(true); return; }
        var loader = window.DrSknnHomepageV2Performance;
        if (loader && typeof loader.loadPricing === "function") {
          Promise.resolve().then(function () { return loader.loadPricing(); }).then(finish, function () { finish(false); });
          return;
        }
        // Standalone pricing pages load their controller with defer. The global
        // header can become ready first, so wait for that controller without scrolling.
        window.setTimeout(attempt, 80);
      }
      attempt();
    });
  }

  function openTreatmentFinder(destination, trigger) {
    var href = destination || TREATMENT_FINDER_URL;
    var target;
    try { target = new URL(href, window.location.href); } catch (_) { return Promise.resolve(false); }
    var returnTrigger = bookingReturnTrigger(trigger || document.activeElement);
    closeNavigation();
    var pricing = document.querySelector("[data-drsknn-pricing-v3]");
    var localRestricted = pricing && pricing.dataset.pricingV3Catalogue === "advertising";
    var targetRestricted = target.searchParams.get("view") === "drsknn-pricing-v3-adsafe";
    var localCompatible = pricing && target.origin === window.location.origin && Boolean(localRestricted) === targetRestricted;
    if (!localCompatible) {
      var current = new URL(window.location.href);
      if (target.pathname !== current.pathname || target.searchParams.get("view") !== current.searchParams.get("view") || target.origin !== current.origin) {
        window.location.assign(href);
      } else {
        bookingLoadNotice("Booking options could not load. Reload this page to try again.", href, returnTrigger);
      }
      return Promise.resolve(false);
    }
    if (treatmentRequest) return treatmentRequest.promise;
    var retryUrl = new URL(window.location.href);
    retryUrl.searchParams.set("open", "treatment");
    retryUrl.hash = "";
    var retryHref = retryUrl.toString();
    var requestId = ++treatmentRequestId;
    var notice = bookingLoadNotice("Opening treatment booking…", "", returnTrigger);
    if (returnTrigger) returnTrigger.setAttribute("aria-busy", "true");
    var request = { trigger: returnTrigger, promise: null };
    treatmentRequest = request;
    request.promise = loadBookingCatalogue().then(function (ready) {
      if (requestId !== treatmentRequestId) return false;
      if (returnTrigger) returnTrigger.removeAttribute("aria-busy");
      treatmentRequest = null;
      if (ready) {
        notice.remove();
        try {
          if (window.DrSknnPricingV3.openBookingFinder(returnTrigger) !== false) return true;
        } catch (_) {}
      }
      // The lazy loader caches failures. A deliberate reload is a real retry;
      // silently revisiting the pricing anchor would strand the patient again.
      bookingLoadNotice("Booking options could not load. Reload this page to try again.", retryHref, returnTrigger);
      return false;
    });
    return request.promise;
  }

  function scheduleRequestedTreatment() {
    if (treatmentHandoffScheduled) return;
    try {
      if (new URLSearchParams(window.location.search || "").get("open") !== "treatment") return;
    } catch (_) { return; }
    treatmentHandoffScheduled = true;
    openTreatmentFinder(window.location.href, null);
  }

  window.openDrSknnTreatmentFinder = openTreatmentFinder;
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("a[data-drsknn-treatment-finder]");
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openTreatmentFinder(link.getAttribute("href"), link);
  });

  function initHeaderSearchBridge() {
    if (document.documentElement.dataset.drsknnHeaderSearchBridgeReady === "true") return;
    document.documentElement.dataset.drsknnHeaderSearchBridgeReady = "true";

    function surfaces() {
      var compactSearch = document.querySelector(".header .header-full-width-search");
      var modalRoot = document.querySelector(".header .header__search");
      return {
        compactSearch: compactSearch,
        compactForm: compactSearch && compactSearch.querySelector("form.search"),
        compactInput: compactSearch && compactSearch.querySelector('input[type="search"]'),
        compactSubmit: compactSearch && compactSearch.querySelector('button[type="submit"]'),
        modalRoot: modalRoot,
        modalDetails: modalRoot && modalRoot.querySelector("details"),
        modalSummary: modalRoot && modalRoot.querySelector("summary"),
        modalInput: modalRoot && modalRoot.querySelector('input[type="search"]')
      };
    }

    function setModalRootVisible(current, visible) {
      if (!current.modalRoot) return;
      if (visible) {
        current.modalRoot.setAttribute("data-drsknn-search-bridge", "true");
        current.modalRoot.style.setProperty("display", "block", "important");
      } else {
        current.modalRoot.removeAttribute("data-drsknn-search-bridge");
        current.modalRoot.style.removeProperty("display");
      }
    }

    function closeCompetingLayers() {
      closeNavigation();
      var cartDrawer = document.querySelector("cart-drawer.active");
      if (cartDrawer && typeof cartDrawer.close === "function") cartDrawer.close();
    }

    function openSearch(event) {
      var current = surfaces();
      if (!current.compactInput || !current.modalRoot || !current.modalDetails || !current.modalSummary || !current.modalInput) return;
      if (current.compactInput.value.trim()) return;
      event.preventDefault();
      closeCompetingLayers();
      setModalRootVisible(current, true);
      /* Wait until the compact-button click has finished bubbling. Opening the
         theme modal synchronously would attach its outside-click listener in
         time for that same click to close it again. */
      window.requestAnimationFrame(function () {
        if (!current.modalDetails.open) current.modalSummary.click();
        if (!current.modalDetails.open) {
          current.modalDetails.setAttribute("open", "");
          current.modalSummary.setAttribute("aria-expanded", "true");
          document.body.classList.add("overflow-hidden");
        }
        window.requestAnimationFrame(function () {
          current.modalInput.focus({ preventScroll: true });
        });
      });
    }

    /* Delegation keeps the bridge attached if Shopify refreshes header markup. */
    document.addEventListener("click", function (event) {
      var trigger = event.target.closest && event.target.closest('.header .header-full-width-search button[type="submit"]');
      if (trigger) openSearch(event);
    }, true);
    document.addEventListener("submit", function (event) {
      if (event.target.matches && event.target.matches(".header .header-full-width-search form.search")) openSearch(event);
    }, true);
    document.addEventListener("toggle", function (event) {
      if (!event.target.matches || !event.target.matches(".header .header__search details")) return;
      var current = surfaces();
      if (event.target.open) {
        setModalRootVisible(current, true);
      } else {
        setModalRootVisible(current, false);
        document.body.classList.remove("overflow-hidden");
      }
    }, true);
  }

  function requestedConsultation() {
    var path = String(window.location.pathname || "").toLowerCase();
    if (path !== HOME && path !== PREVIEW_HOME) return false;
    try {
      var requested = new URLSearchParams(window.location.search || "").get("open") || "";
      return requested === "consultation" || requested === "booking";
    } catch (_) {
      return false;
    }
  }

  function scheduleRequestedConsultation() {
    if (scheduled || !requestedConsultation()) return;
    scheduled = true;
    document.documentElement.dataset.drsknnHeaderV3Handoff = "waiting";
    var attempts = 0;
    function tryOpen() {
      if (document.querySelector('[data-v5-modal="consultation"].is-open')) {
        document.documentElement.dataset.drsknnHeaderV3Handoff = "open";
        return;
      }
      if (typeof window.drsknnOpenConsultationChooser === "function") {
        window.drsknnOpenConsultationChooser();
        document.documentElement.dataset.drsknnHeaderV3Handoff = "controller";
        return;
      }
      var root = document.querySelector("[data-drsknn-v5]");
      var local = root && root.querySelector("[data-v5-open-consultation]");
      if (local && root.dataset.v5Ready === "1") {
        local.click();
        document.documentElement.dataset.drsknnHeaderV3Handoff = "trigger";
        return;
      }
      attempts += 1;
      document.documentElement.dataset.drsknnHeaderV3Attempts = String(attempts);
      if (attempts < 50) window.setTimeout(tryOpen, 120);
      else document.documentElement.dataset.drsknnHeaderV3Handoff = "timed-out";
    }
    window.setTimeout(tryOpen, 80);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initHeaderSearchBridge();
      scheduleRequestedConsultation();
      scheduleRequestedTreatment();
    }, { once: true });
  } else {
    initHeaderSearchBridge();
    scheduleRequestedConsultation();
    scheduleRequestedTreatment();
  }
  window.addEventListener("pageshow", scheduleRequestedConsultation);
  window.addEventListener("pageshow", scheduleRequestedTreatment);
})();
